import { render } from "./AposAvatar.vue?vue&type=template&id=107c48b7&scoped=true"
import script from "./AposAvatar.vue?vue&type=script&lang=js"
export * from "./AposAvatar.vue?vue&type=script&lang=js"

import "./AposAvatar.vue?vue&type=style&index=0&id=107c48b7&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107c48b7"],['__file',"ui/ui/apos/components/AposAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "107c48b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('107c48b7', __exports__)) {
    api.reload('107c48b7', __exports__)
  }
  
  module.hot.accept("./AposAvatar.vue?vue&type=template&id=107c48b7&scoped=true", () => {
    api.rerender('107c48b7', render)
  })

}


export default __exports__